import React from 'react';

import { performCatalogSearch } from 'app/actions/SearchActions';
import BrowseSearchPage from 'app/components/browse/search';
import { BROWSE_SEARCH_PAGE_FACET_FIELD_IDS, FILTERABLE_DISPLAY_BIB_GRID_LIMIT } from 'app/constants/BrowseConstants';
import { mapQueryStateToCatalogSearchParams } from 'app/helpers/browse';
import { deserializeQuerystring } from 'app/helpers/browse/searchPageQueryHelpers';
import connectRoute from 'app/routes/connectRoute';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';

const getRouteData = ({ dispatch, location, state }) => {
  const searchScopes = selectCurrentSiteScopes(state)?.toJS() ?? [];

  const searchParams = new URLSearchParams(location.search);
  const baseQuery = Object.fromEntries(searchParams);

  const includedFieldIds = BROWSE_SEARCH_PAGE_FACET_FIELD_IDS;
  const catalogSearchFilters = mapQueryStateToCatalogSearchParams(
    deserializeQuerystring(searchParams, {
      includedFieldIds,
      searchScopes
    }),
    { includedFieldIds }
  );

  return [
    dispatch(performCatalogSearch({ ...baseQuery, limit: FILTERABLE_DISPLAY_BIB_GRID_LIMIT, ...catalogSearchFilters }))
  ];
};

const BrowseSearchPageRoute = () => {
  return <BrowseSearchPage />;
};

export default connectRoute(BrowseSearchPageRoute, { getRouteData });
